module.exports = __webpack_public_path__ + "static/img/newLoad_teacher.7e35ecb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/download/newLoad_teacher.png
// module id = 7aaW
// module chunks = 3